import revive_payload_client_4sVQNw7RlN from "/usr/src/app/web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/usr/src/app/web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/src/app/web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/usr/src/app/web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/usr/src/app/web/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/usr/src/app/web/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/usr/src/app/web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/usr/src/app/web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/usr/src/app/web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/src/app/web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ZGw8LlWmeq from "/usr/src/app/web/node_modules/nuxt3-notifications/dist/runtime/plugin.mjs";
import slideovers_X7whXyrIWR from "/usr/src/app/web/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/usr/src/app/web/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/usr/src/app/web/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/usr/src/app/web/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/usr/src/app/web/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import quill_editor_hICdehhmgb from "/usr/src/app/web/plugins/quill-editor.ts";
import ImgUrl_mHQ3eEco1c from "/usr/src/app/web/plugins/ImgUrl.ts";
import googleGeocode_kPC5o7zJ73 from "/usr/src/app/web/plugins/googleGeocode.ts";
import google_analytics_client_KruZkwwzId from "/usr/src/app/web/plugins/google-analytics.client.ts";
import axiosPlugin_baMq18zR4r from "/usr/src/app/web/plugins/axiosPlugin.ts";
import formatCurrency_Ud4HNt2xAs from "/usr/src/app/web/plugins/formatCurrency.ts";
import googleAuthPlugin_uivoxx8kCB from "/usr/src/app/web/plugins/googleAuthPlugin.ts";
import i18n_VfGcjrvSkj from "/usr/src/app/web/plugins/i18n.ts";
import maska_UHaKf2z1iQ from "/usr/src/app/web/plugins/maska.ts";
import productUrl_mWP6zI1fy3 from "/usr/src/app/web/plugins/productUrl.ts";
import sentry_client_shVUlIjFLk from "/usr/src/app/web/plugins/sentry.client.ts";
import utilityPlugin_FqOQYOYX7H from "/usr/src/app/web/plugins/utilityPlugin.ts";
import vueGoogleMaps_8xmoAwKZvr from "/usr/src/app/web/plugins/vueGoogleMaps.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ZGw8LlWmeq,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  quill_editor_hICdehhmgb,
  ImgUrl_mHQ3eEco1c,
  googleGeocode_kPC5o7zJ73,
  google_analytics_client_KruZkwwzId,
  axiosPlugin_baMq18zR4r,
  formatCurrency_Ud4HNt2xAs,
  googleAuthPlugin_uivoxx8kCB,
  i18n_VfGcjrvSkj,
  maska_UHaKf2z1iQ,
  productUrl_mWP6zI1fy3,
  sentry_client_shVUlIjFLk,
  utilityPlugin_FqOQYOYX7H,
  vueGoogleMaps_8xmoAwKZvr
]